(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.Service = (function() {
    function Service(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this._postPermissionsCheck = bind(this._postPermissionsCheck, this);
      this._postBroadcast = bind(this._postBroadcast, this);
      return;
    }


    /*
     * Executes a post to the given url with the given request, and when it completes,
     * fires the given event on @rootScope, passing the following object structure:
     *
     * {
     *     request: request <- this is the request data that was passed in to _postBroadcast()
     *     response: response <- the actual response from the post
     * }
     *
     */

    Service.prototype._postBroadcast = function(request, url, event) {
      var post;
      post = this.http.post(url, request);
      post.then((function(_this) {
        return function(response) {
          return _this.rootScope.$broadcast(event, {
            request: request,
            response: response
          });
        };
      })(this));
      return post;
    };

    Service.prototype._postPermissionsCheck = function(id, url) {
      return this.http.post(url, {
        id: id
      });
    };

    Service.prototype.handleJsonResponse = function(jsr) {
      var ref, ref1, ref2;
      if (((ref = jsr.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) === 'success') {
        return (ref2 = jsr.data) != null ? ref2.data : void 0;
      } else {
        return null;
      }
    };

    return Service;

  })();

}).call(this);
